/**
 * @internal
 */
export const FindHighlightRuleKey = '_RoosterjsFindHighlight';

/**
 * @internal
 */
export const FindHighlightStyleKey = 'roostersFindHighlight';

/**
 * @internal
 */
export const FindHighlightSelector = `::highlight(${FindHighlightStyleKey})`;

/**
 * @internal
 */
export const ReplaceHighlightRuleKey = '_RoosterjsReplaceHighlight';

/**
 * @internal
 */
export const ReplaceHighlightStyleKey = 'roostersReplaceHighlight';

/**
 * @internal
 */
export const ReplaceHighlightSelector = `::highlight(${ReplaceHighlightStyleKey})`;

/**
 * @internal
 */
export const ScrollMargin = 20;
